(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oso-accessories-shop"] && !Shopify.designMode) return;
  try {
    
function initializeOsoAccessories(scope = document) {
  scope.querySelectorAll('[data-oso-accessories]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const controls = root.querySelector('.oso-accessories-filters');
    const buttons = [...root.querySelectorAll('button[data-category]')];
    const cards = [...root.querySelectorAll('[data-accessory]')];
    const instrument = root.querySelector('select[data-instrument]');
    const mallet = root.querySelector('select[data-mallet-type]');
    let category = 'all';
    const validValue = (select, value) => [...select.options].some(option => option.value === value) ? value : 'all';
    function render(updateUrl = false) {
      if (category !== 'mallets') mallet.value = 'all';
      root.querySelector('[data-mallet-filter]').hidden = category !== 'mallets';
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
      let count = 0;
      cards.forEach(card => {
        const visible = (category === 'all' || card.dataset.category === category) && (instrument.value === 'all' || card.dataset.instrument === instrument.value) && (mallet.value === 'all' || card.dataset.malletType === mallet.value);
        card.hidden = !visible;
        if (visible) count++;
      });
      root.querySelector('[data-results]').textContent = root.dataset.countLabel.replace('__COUNT__', String(count));
      root.querySelector('[data-empty]').hidden = count > 0;
      if (updateUrl) {
        const url = new URL(window.location.href);
        [['accessories_category',category],['instrument',instrument.value],['mallet_type',mallet.value]].forEach(([key,value]) => value === 'all' ? url.searchParams.delete(key) : url.searchParams.set(key,value));
        window.history.replaceState(null, '', url);
      }
    }
    function readUrl() {
      const params = new URLSearchParams(window.location.search);
      const requestedCategory = params.get('accessories_category');
      category = buttons.some(button => button.dataset.category === requestedCategory) ? requestedCategory : 'all';
      instrument.value = validValue(instrument, params.get('instrument'));
      mallet.value = validValue(mallet, params.get('mallet_type'));
      render();
    }
    buttons.forEach(button => button.addEventListener('click', () => {category = button.dataset.category; render(true);}));
    instrument.addEventListener('change', () => render(true));
    mallet.addEventListener('change', () => render(true));
    root.querySelector('[data-reset]').addEventListener('click', () => {category = 'all'; instrument.value = 'all'; mallet.value = 'all'; render(true);});
    window.addEventListener('popstate', readUrl);
    controls.hidden = false;
    readUrl();
  });
}
initializeOsoAccessories();
document.addEventListener('shopify:section:load', event => initializeOsoAccessories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oso-bowl-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('oso-category-gallery')) {
  class OsoCategoryGallery extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.oso-gallery__card'));
      this.grid = this.querySelector('.oso-gallery__grid');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.updateMotion();
        });
      };
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.reduced.addEventListener('change', this.schedule);
      this.addEventListener('focusin', this.schedule);
      this.addEventListener('focusout', this.schedule);
      this.schedule();
    }
    updateMotion() {
      if (!this.grid) return;
      const disabled = this.dataset.motion === 'false' || this.reduced.matches || this.contains(document.activeElement);
      const viewport = window.innerHeight;
      const mobile = window.innerWidth < 750;
      const top = this.grid.getBoundingClientRect().top;
      this.cards.forEach((card, index) => {
        const naturalTop = top + card.offsetTop;
        const progress = disabled ? 1 : Math.min(1, Math.max(0, (viewport * .96 - naturalTop) / (viewport * .66)));
        const remaining = 1 - progress * progress * (3 - 2 * progress);
        const lift = mobile ? 48 : 135 + index * 50;
        card.style.setProperty('--oso-y', (remaining * lift).toFixed(2) + 'px');
        card.style.setProperty('--oso-x', (mobile ? 0 : remaining * (1 - index) * 105).toFixed(2) + 'px');
        card.style.setProperty('--oso-card-scale', (1 - remaining * (mobile ? .02 : .07)).toFixed(4));
        card.style.setProperty('--oso-scale', (1 + remaining * .03).toFixed(4));
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.reduced.removeEventListener('change', this.schedule);
      this.removeEventListener('focusin', this.schedule);
      this.removeEventListener('focusout', this.schedule);
    }
  }
  customElements.define('oso-category-gallery', OsoCategoryGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oso-editorial-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', function(event) {
  if (event.target.matches('.oso-story__film') && !event.target.open) {
    event.target.querySelectorAll('video').forEach(function(video) { video.pause(); });
  }
}, true);

  } catch(e) { console.error(e); }
})();
})();
